var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con"},[_c('vue-tinymce',{attrs:{"id":"myEdit","setting":_vm.setting},on:{"change":_vm.iseditchang},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }